angular.module('tf.controllers')
.controller("mainController",['$scope','WebSocketService','HttpService','$rootScope','$alert',
        function($scope, WebSocketService, HttpService, $rootScope, $alert){


        $scope.fid = "V++eL2rX4bc=";

        WebSocketService.createWS();
        WebSocketService.on('progress', handleProgress);

        function handleProgress(message){
            $scope.$apply(function(){
                $scope.bar.width = message.data + "%";
            });
        }
        $scope.startBar = function(){
            $scope.bar = {width:'0%'};
            WebSocketService.send('start-bar');
        };


        $scope.closeConnection = function(){
            HttpService.get("farmer/" + $scope.fid + "/disconnect").then(function(res){
                console.log(res.data);
            });
        };

        $scope.args = {getFolders: null, getProject: null, getImage: null};
        $scope.getFolders = function(args){
            var params = args? {args:args} : null;
            HttpService.get("farmer/" + $scope.fid + "/folders", params).then(function(res){
                console.log(res.data);
            });
        };
        $scope.getProject = function(args){
            var params = args? {args:args} : null;
            HttpService.get("farmer/" + $scope.fid + "/project", params).then(function(res){
                console.log(res.data);
            });
        };
        $scope.getImage = function(args){
            var params = args? {image:args} : null;
            HttpService.get("farmer/" + $scope.fid + "/image", params).then(function(res){
                console.log(res.data);
            });
        };
        $scope.render = function(args){
            HttpService.post("farmer/" + $scope.fid + "/render", {args:args}).then(function(res){
                console.log(res.data);
            });
        };
        $scope.cancelRender = function(args){
            HttpService.post("farmer/" + $scope.fid + "/cancel_render", {args:args}).then(function(res){
                console.log(res.data);
            });
        };
        $scope.getSchedule = function(args){
            HttpService.get("farmer/" + $scope.fid + "/schedule", {args:args}).then(function(res){
                console.log(res.data);
            });
        };
        $scope.setSchedule = function(args){
            HttpService.post("farmer/" + $scope.fid + "/schedule", {args:args}).then(function(res){
                console.log(res.data);
            });
        };
        $scope.imageUrl = '';
        $scope.imageSecureUrl = '';
        //$scope.progressbar = ngProgressFactory.createInstance();
        var myAlert1 = $alert({title: 'Holy guacamole!', content: 'Best check yo self, you\'re not looking too good.', placement: 'top', type: 'info', keyboard: true, show: false});
        var myAlert2 = $alert({title: 'Holy guacamole!', content: 'Best check yo self, you\'re not looking too good.', container: "#alerts-container", type: 'info', keyboard: true, show: false});
        $scope.alert2 = myAlert2;
        $scope.showAlert = function() {
            myAlert2.toggle(); // or myAlert.$promise.then(myAlert.show) if you use an external html template
        };
        $scope.alert = {title: 'Holy guacamole!', content: 'Best check yo self, you\'re not looking too good.', type: 'error'};
        $scope.pop = function(){


        };

    }])


.directive('bindName', [function() {
    return {
        //template: '<span>{{val}}</span>',
        template: '<uib-progressbar max="100" value="val"><span style="color:white; white-space:nowrap;">{{val}}</span></uib-progressbar>',
        link: function(scope,element,attr){
            scope.$on("abc", function(a1,a2){
                scope.$apply(function(){
                    scope.val = a2.val;
                    if(a2.val >= 100){
                        scope.val = 100;
                    }
                });
            });


        }
    };
}])
;